import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationHeader from '../../components/ui/NavigationHeader';
import ClientForm from './components/ClientForm';
import SuccessMessage from './components/SuccessMessage';
import BreadcrumbNavigation from './components/BreadcrumbNavigation';
import { clientApiService } from '../../utils/clientApiService';

const AddNewClient = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [createdClient, setCreatedClient] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleFormSubmit = async (clientData) => {
    setIsLoading(true);
    setError(null);

    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1500));

      // Use the backend API to add the client
      const newClient = await clientApiService.addClient(clientData);

      setCreatedClient(newClient);
      setShowSuccess(true);
    } catch (error) {
      console.error('Error creating client:', error);
      setError(error.message || 'Failed to create client. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/client-dashboard');
  };

  const handleAddMinutes = () => {
    // Navigate to client detail page with add minutes action
    navigate(`/client-detail/${createdClient.id}`, { 
      state: { action: 'add-minutes' } 
    });
  };

  const handleReturnToDashboard = () => {
    navigate('/client-dashboard');
  };

  const handleCreateAnother = () => {
    setShowSuccess(false);
    setCreatedClient(null);
    setError(null);
    // Reset form by remounting component
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader />
      
      <main className="pt-20 pb-12">
        <div className="max-w-2xl mx-auto px-6">
          <BreadcrumbNavigation />
          
          {/* Error Message */}
          {error && (
            <div className="mb-6 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 text-destructive">⚠️</div>
                <p className="text-destructive font-medium">{error}</p>
              </div>
            </div>
          )}
          
          {showSuccess && createdClient ? (
            <SuccessMessage
              clientData={createdClient}
              onAddMinutes={handleAddMinutes}
              onReturnToDashboard={handleReturnToDashboard}
              onCreateAnother={handleCreateAnother}
            />
          ) : (
            <ClientForm
              onSubmit={handleFormSubmit}
              onCancel={handleCancel}
              isLoading={isLoading}
            />
          )}
        </div>
      </main>
    </div>
  );
};

export default AddNewClient;